<script>
import genericService from '../../services/genericService';
import NotificationService from '../../services/notifications';
import Utils from '../../common/Utils';

import CommonConstants from '../../common/Constants';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import Toolbar from 'primevue/toolbar';
// import AutoComplete from 'primevue/autocomplete';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericCustomMultiSelect from '../../components/generic/GenericCustomMultiSelect.vue'

import { required, helpers  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

const maxThreeDays = helpers.withMessage('Validity must be maximum three days', function(){
    return !(this.data.validFrom && this.data.validTo) || ((Math.ceil(Math.abs(this.data.validFrom - this.data.validTo) / (1000 * 60 * 60 * 24))) <= 3);
});

// const emails = helpers.withMessage('Value is not a valid list of email address', function(items){
//     return !items || (items.every((item) => String(item)
//     .toLowerCase()
//     .match(
//       /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//     )));
// });

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    Toolbar,
    InputText,
    Calendar,
    ResponsiveButton,
    GenericCustomMultiSelect
    // AutoComplete
},
  props: [],
  data(){
    return {
      data: {},
      submitted: false,
      rangeOverThreeDays: false,
      allUsers: [],
      filteredUsers: [],
      idThread: Number(this.$route.params.id),
    }
  },
  validations(){
    return {
      data: {
        threadName: { required },
        validFrom: { required },
        validTo: { required, maxThreeDays },
        users: { required },
      }
    }
  },
  mounted(){
    // this.getAllUsers();
    if (this.idThread) {
      if (!this.$store.state.notifications.threads[0]) {
        NotificationService.getThreads(({success, data}) => {
          if(success){
            this.$store.dispatch("notifications/setThreads", data);
            let currentThread = this.$store.state.notifications.threads.find((item) => item.id === Number(this.idThread));
            if(!Array.isArray(currentThread?.users)){
              currentThread.users = [...new Set(currentThread?.users.split(','))].filter((item) => item !== this.$store.state.security.user.username);
            }else{
              currentThread.users = [...new Set(currentThread?.users)].filter((item) => item !== this.$store.state.security.user.username);
            }
            
            currentThread.validFrom = Utils.dateToCurrentTimeZone(currentThread.validFrom);
            currentThread.validTo = Utils.dateToCurrentTimeZone(currentThread.validTo);
            this.data = currentThread;
          }
        });
      } else {
        let currentThread = this.$store.state.notifications.threads.find((item) => item.id === Number(this.idThread));
        if(!Array.isArray(currentThread?.users)){
          currentThread.users = [...new Set(currentThread?.users.split(','))].filter((item) => item !== this.$store.state.security.user.username);
        }else {
          currentThread.users = [...new Set(currentThread?.users)].filter((item) => item !== this.$store.state.security.user.username);

        }
        currentThread.validFrom = Utils.dateToCurrentTimeZone(currentThread.validFrom);
        currentThread.validTo = Utils.dateToCurrentTimeZone(currentThread.validTo);
        this.data = currentThread;
      }
    }
  },
  computed: {
      constants(){
          return CommonConstants;
      }
  },
  methods: {
    goBack(){
        this.$router.back();
    },
    searchUser({query}) {
      this.filteredUsers = this.allUsers.filter((el) => el.toLowerCase().includes(query.toLowerCase()));
    },
    async getAllUsers () {
      await genericService.get('security/user').then(({data}) => {
        this.allUsers = data.filter(({username}) => username !== this.$store.state.security.user.username).map(({username}) => username);
      });
    },
    handleSubmit(valid){
      this.submitted = true;

      if (valid) {
        const body = {
        ...this.data,
        users: [...new Set([...this.data.users, this.$store.state.security.user.username])].join(',')
        }

        if (this.idThread) {
          NotificationService.editThread(body, ({success, message}) => {
            success && this.goBack();
          });
        } else {
          NotificationService.addThread(body, ({success, message}) => {
            success && this.goBack();
          });
        }

      }
    }
  }
}

</script>

<template>
  <main>
    <Toolbar style="padding: 0;">
      <template #start>
        <ResponsiveButton :label="$t('btn.back')" icon="pi pi-arrow-left" class="p-button-outlined p-button-sm m-1" @click="goBack" />
        <ResponsiveButton :label="$t('btn.send')" icon="pi pi-send" class="p-button-sm m-1" @click="handleSubmit(!v$.$invalid)"/>
      </template>
      </Toolbar>
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <div class="grid formgrid">
            <div class="col-12 lg:col-6 field">
              <label for="threadName" :class="{'p-error':v$.data.threadName.$invalid && submitted}">{{$t('thread.threadName')}}</label>
              <InputText
              id="threadName" type="text"
              :disabled="Boolean(idThread)"
              v-model="data.threadName"
              :class="{'p-invalid':v$.data.threadName.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
              <div v-if="(v$.data.threadName.$invalid && submitted) || v$.data.threadName.$pending.$response">
                <small class="p-error" v-for="error in v$.data.threadName.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
              </div>
            </div>
            <div class="col-12 lg:col-3 field">
              <label for="validFrom" :class="{'p-error':v$.data.validFrom.$invalid && submitted}">{{$t('thread.validFrom')}}</label>
              <Calendar
              :placeholder="constants.DATE_PLACEHOLDER_POINT"
              :dateFormat="constants.DATE_FORMAT_POINT"
              :showTime="true" :hideOnDateTimeSelect="true"
              :disabled="Boolean(idThread)"
              id="validFrom"
              v-model="data.validFrom"
              :showIcon="true" :showButtonBar="true" :yearNavigator="true"
              :class="{'p-invalid':v$.data.validFrom.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
              <div v-if="(v$.data.validFrom.$invalid && submitted) || v$.data.validFrom.$pending.$response">
                <small class="p-error" v-for="error in v$.data.validFrom.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
              </div>
            </div>
            <div class="col-12 lg:col-3 field">
              <label for="validTo" :class="{'p-error':v$.data.validTo.$invalid && submitted}">{{$t('thread.validTo')}}</label>
              <Calendar
              :placeholder="constants.DATE_PLACEHOLDER_POINT"
              :dateFormat="constants.DATE_FORMAT_POINT"
              :showTime="true" :hideOnDateTimeSelect="true"
              :disabled="Boolean(idThread)"
              id="validTo"
              v-model="data.validTo"
              :showIcon="true" :showButtonBar="true" :yearNavigator="true"
              :class="{'p-invalid':v$.data.validTo.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
              <div v-if="(v$.data.validTo.$invalid && submitted) || v$.data.validTo.$pending.$response">
                <small class="p-error" v-for="error in v$.data.validTo.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
              </div>
            </div>
            <div class="col-12 field">
              <label for="users" :class="{'p-error':v$.data.users.$invalid && submitted}">{{$t('thread.users')}}</label>
              <GenericCustomMultiSelect 
                :name="'users'"
                v-model="data.users" 
                api="security/user"
                :disableStore="false"
                :format="{label: 'username', value: 'username'}"
                :class="{'p-invalid':v$.data.users.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
              <!-- <GenericCustomMasterDataMultiSelect 
              id="users" 
              :multiple="true" 
              v-model="data.users" 
              :suggestions="filteredUsers" 
              @complete="searchUser($event)" 
              optionLabel="name" 
              class="users"
              :class="{'p-invalid':v$.data.users.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> -->
              <div v-if="(v$.data.users.$invalid && submitted) || v$.data.users.$pending.$response">
                <small class="p-error" v-for="error in v$.data.users.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<style lang="scss">

.p-autocomplete {
  .p-autocomplete-multiple-container {
    width: 100%;
  }
}

</style>